import {Avatar, Select} from 'antd';
import React, {useState} from 'react';

import styles from './style.module.scss';
import {CaretDownFilled} from '@ant-design/icons';
import {getLocalesByKey as t} from '@/utils/translation';
import {opaqueColor} from '@/utils/colors';
import classNames from 'classnames';

interface UserProps {
  avatar: string;
  email: string;
  isOwner?: boolean;
  permission?: string;
  onPermissionChange?: (email: string, permission: string, closeAfterSubmit?: boolean) => void;
}

const {Option} = Select;

export const User: React.FC<UserProps> = ({
  avatar,
  email,
  isOwner,
  permission,
  onPermissionChange,
}) => {
  const [activePermission, setActivePermission] = useState(permission);

  return (
    <div className={styles.user}>
      <div className={styles.avatar}>
        <Avatar style={{backgroundColor: opaqueColor('#34AEF3', 20), color: '#34AEF3'}}>{avatar}</Avatar>
      </div>
      <div className={styles.info}>
        <p className={styles.email}>{email}</p>
      </div>
      {!isOwner ? <Select
        value={activePermission}
        onChange={value => {
          setActivePermission(value);
          onPermissionChange(email, value, false);
        }}
        suffixIcon={<CaretDownFilled style={{color: '#121212'}}/>}
        className={classNames(styles.customSelect, styles.individualCustomSelect)}>
        <Option value='view'>{t('can-view')}</Option>
        <Option value='edit'>{t('can-edit')}</Option>
        <Option value='revoke'>{'Revoke Permissions'}</Option>
      </Select> : <div style={{fontSize: 12, color: '#4E5156', marginRight: 10}}>Owner</div>}
    </div>
  );
};


